/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionconfirmnopush3Inputs */

const en_actionconfirmnopush3 = /** @type {(inputs: Actionconfirmnopush3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It ends before 8 am, so it goes out without a push. One action per day.`)
};

const de_actionconfirmnopush3 = /** @type {(inputs: Actionconfirmnopush3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie endet vor 8 Uhr und geht deshalb nicht als Mitteilung raus. Pro Tag geht eine Aktion.`)
};

/**
* | output |
* | --- |
* | "It ends before 8 am, so it goes out without a push. One action per day." |
*
* @param {Actionconfirmnopush3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionconfirmnopush3 = /** @type {((inputs?: Actionconfirmnopush3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionconfirmnopush3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionconfirmnopush3(inputs)
	return de_actionconfirmnopush3(inputs)
});
export { actionconfirmnopush3 as "actionConfirmNoPush" }